import React from 'react';

function Hero() {
  const handleScroll = () => {
    const storySection = document.querySelector('.story');
    if (storySection) {
      storySection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-image">
          <img src="/tmt-portrait.png" alt="T.M. Theagarajan" />
        </div>
        <div className="hero-text">
          <h1>Learning Fluency: The Only Skill That Matters</h1>
          <p>
            TMT Learning Center's mission is to make the next generation fluent in learning
          </p>
          <button className="cta-button" onClick={handleScroll}>
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;